import validate from '../../../services/reduxValidate.js';

export default function(data) {
  const validators = {
    'availability_date': {
      isoDate: true,
      presence: true,
    },
    'tjm': {
      presence: true,
      numericality: {
        greaterThan: 0,
        lessThan: 50000,
        notGreaterThan: 'Votre TJM doit être supérieur a 0€',
        notLessThan: 'Votre TJM doit être inférieur à 50 000€'
      }
    },
    'comment': {
      presence: true,
    }
  };

  return validate(data, validators);
}